module.exports = __webpack_public_path__ + "images/emoji/ideograph_advantage.88486fe98d3584d97365.png";